export const formatFileSize = (bytes?: number): string | undefined => {
  if (bytes === undefined || bytes === null || !Number.isFinite(bytes) || bytes < 0) {
    return undefined;
  }

  if (bytes === 0) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** exponent;
  const roundedValue = value >= 10 || exponent === 0 ? Math.round(value) : Math.round(value * 10) / 10;

  return `${roundedValue} ${units[exponent]}`;
};
